// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details-flyout {\n  transform: translateX(100%);\n  transition: transform 0.25s ease;\n}\n\n.details-flyout.active {\n  transform: translateX(0);\n}\n", ""]);
// Exports
module.exports = exports;
